<div class="dialog-container">
  <div class="navigation-bar">
    @if(view() === 'details') {
      <button class="back-btn" mat-icon-button (click)="backToSearch()">
        <mat-icon>arrow_back</mat-icon>
      </button>
    }
    <button class="close-btn" mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <p class="title">Order Search</p>

  @if(view() === 'search') {
    <form class="search-form" [formGroup]="form" (ngSubmit)="search()">
      <mat-form-field>
        <mat-label>Search Term</mat-label>
        <input matInput formControlName="searchTerm">
      </mat-form-field>

      <button matButton="elevated" class="submit-button" type="submit">Search</button>
    </form>

    @if (errorMessage()) {
      <div class="error-message">{{ errorMessage() }}</div>
    }
    @if (isBusy()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    @if (rows() && rows()!.length === 0) {
      <div class="no-results">
        No results found.
      </div>
    }

    @if (dataSource && dataSource.data?.length) {
      <div class="results-table">
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2 bordered-table">
          <ng-container matColumnDef="orderNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Order Number </th>
            <td mat-cell *matCellDef="let row"> {{ row.orderNumber }} </td>
          </ng-container>
          <ng-container matColumnDef="orderType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Order Type </th>
            <td mat-cell *matCellDef="let row"> {{ row.orderType }} </td>
          </ng-container>
          <ng-container matColumnDef="customerNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Customer Number </th>
            <td mat-cell *matCellDef="let row"> {{ row.customerNumber }} </td>
          </ng-container>
          <ng-container matColumnDef="customerName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Customer Name </th>
            <td mat-cell *matCellDef="let row"> {{ row.customerName }} </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
            <td mat-cell *matCellDef="let row"> {{ row.status }} </td>
          </ng-container>
          <ng-container matColumnDef="customerPo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Customer PO </th>
            <td mat-cell *matCellDef="let row"> {{ row.customerPo }} </td>
          </ng-container>
          <ng-container matColumnDef="enteredDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Order Date </th>
            <td mat-cell *matCellDef="let row"> {{ row.enteredDate | date:'MM-dd-yy' }} </td>
          </ng-container>
          <ng-container matColumnDef="projectName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Project Name </th>
            <td mat-cell *matCellDef="let row"> {{ row.projectName }} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="openDetails(row)" class="clickable-row"
          tabindex="0" (keydown.enter)="openDetails(row)"></tr>
        </table>
      </div>
    }
  }
  @if(view() === 'details') {
    <app-prms-order-search-details [prmsOrderSummary]="selectedOrder()!" (close)="close()"></app-prms-order-search-details>
  }
</div>